import React from "react";
import { Select } from "antd";
import TextArea from "antd/lib/input/TextArea";
import FormModal from "../../../../common/FormModal";

const { Option } = Select;
const UserFormModal = ({
  updatePaymentStatusHome,
  setSettlementURL,
  settlementURL,
  getAtmedPaymentsHome,
  id,
  keyName,
  ...props
}) => (
  <FormModal
    {...props}
    formItems={[
      {
        key: "settlement_status",
        label: "Status",
        rules: [{ required: true, message: "Please input User's status!" }],
        Component: (
          <Select size="large" placeholder="Select Status">
            <Option value={false}>Pending</Option>
            <Option value>Completed</Option>
          </Select>
        ),
      },
      {
        key: "notes",
        label: "Notes",

        Component: <TextArea rows={5} placeholder="Enter Notes" />,
      },
    ]}
  />
);
export default UserFormModal;
